/**
 * アプリケーション全体で使用する定数
 */

export const APP_NAME = "AI Deck";

/**
 * canonical URL のベース。SEO 用のため環境を問わず常に本番オリジンを指す
 * （プレビューデプロイや dev の URL が canonical に載ると重複コンテンツ解決が壊れる）
 */
export const CANONICAL_BASE_URL = "https://ai-deck.app";

/**
 * フロントエンドのベースURL（ソーシャルログインのリダイレクト先に使用）
 */
export const FRONTEND_BASE_URL =
  import.meta.env.VITE_FRONTEND_BASE_URL ||
  (import.meta.env.DEV ? "http://localhost:5173" : "https://ai-deck.app");

/**
 * ブログ・ユーザーガイド（apps/content, Astro）のベース URL。
 *
 * 本番は Cloudflare のゾーンルート（apps/content/wrangler.jsonc）が /blog*・/ja/* を
 * コンテンツ Worker に振り分けるため、空文字（＝同一オリジンの相対パス）でよい。
 * 開発時は Astro が別サーバー（4321）なのでオリジンごと向ける。
 *
 * ⚠️ ゾーンルートが効かない環境（Pages のプレビューデプロイ、pnpm preview 等）では
 * 相対パスが SPA の catch-all（404 ページ）に吸われてしまうため、VITE_CONTENT_BASE_URL に
 * https://ai-deck.app を明示的に注入すること。
 */
export const CONTENT_BASE_URL =
  import.meta.env.VITE_CONTENT_BASE_URL ?? (import.meta.env.DEV ? "http://localhost:4321" : "");

/**
 * API リトライ設定
 */
export const API_RETRY_CONFIG = {
  /** 最大リトライ回数 */
  MAX_RETRIES: 1,
  /** 認証エラー時の待機時間 (ミリ秒) */
  AUTH_RETRY_DELAY_MS: 100,
  /** ネットワークエラー時の待機時間 (ミリ秒) */
  NETWORK_RETRY_DELAY_MS: 500,
} as const;
